import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function ShortLink() {
  const { code } = useParams();
  const { resolveShortLink } = useAuth();
  const [err, setErr] = useState('');
  useEffect(() => {
    resolveShortLink(code).then((r) => { window.location.replace(r.url); }).catch(() => setErr('This link has expired or does not exist.'));
    /* eslint-disable-next-line */
  }, [code]);
  return (
    <div className="max-w-md mx-auto px-4 py-20 text-center" data-testid="short-link-page">
      {err ? <p style={{ color: '#8a1f11' }} data-testid="short-link-error">{err}</p>
        : <p className="inline-flex items-center gap-2" style={{ color: 'var(--olive)' }}><Loader2 className="animate-spin" size={16} /> Taking you there…</p>}
    </div>
  );
}
